import { Text } from '@mantine/core';
import classes from './_gridLayout.module.css';

export function C3() {
  return (
    <div className={classes.gridC3}>
      <Text size="sm" color="dimmed">Section C3</Text>
    </div>
  );
} 